import { render, staticRenderFns } from "./QuackReportsData.vue?vue&type=template&id=f4795afc"
import script from "./QuackReportsData.vue?vue&type=script&lang=js"
export * from "./QuackReportsData.vue?vue&type=script&lang=js"
import style0 from "./QuackReportsData.vue?vue&type=style&index=0&id=f4795afc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports